import React from 'react';

export const RiskCard = ({ className = '', children }) => (
  <div className={`bg-white rounded-2xl shadow-sm border border-slate-200 ${className}`}>{children}</div>
);

export const RiskCardHeader = ({ title, subtitle, actions }) => (
  <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
    <div>
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      {subtitle && <p className="text-slate-500 text-sm mt-0.5">{subtitle}</p>}
    </div>
    {actions}
  </div>
);

export const RiskCardBody = ({ className = '', children }) => (
  <div className={`px-6 py-5 ${className}`}>{children}</div>
);

export const RiskBadge = ({ color = 'blue', children }) => {
  const map = {
    blue: 'bg-blue-50 text-blue-700 border border-blue-200',
    amber: 'bg-amber-50 text-amber-700 border border-amber-200',
    green: 'bg-green-50 text-green-700 border border-green-200',
    red: 'bg-red-50 text-red-700 border border-red-200',
    slate: 'bg-slate-50 text-slate-600 border border-slate-200'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${map[color] || map.slate}`}>{children}</span>;
};

export const RiskButton = ({ variant = 'primary', className = '', ...props }) => {
  const base = 'px-4 py-2 rounded-xl text-sm font-semibold transition-all';
  const map = {
    primary: 'bg-gradient-to-r from-orange-600 to-amber-500 hover:opacity-90 text-white',
    outline: 'border border-slate-200 hover:bg-slate-50 text-slate-600',
    ghost: 'text-slate-500 hover:text-slate-700'
  };
  return <button className={`${base} ${map[variant] || map.primary} ${className}`} {...props} />;
};

export const RiskProgress = ({ value = 0 }) => (
  <div className="w-full bg-slate-200 rounded-full h-2">
    <div className="bg-blue-600 h-2 rounded-full transition-all" style={{ width: `${Math.min(100, Math.max(0, value))}%` }}></div>
  </div>
);

export const RiskChip = ({ children, active = false, onClick }) => (
  <button
    onClick={onClick}
    className={`px-3 py-1 rounded-full text-sm border ${active ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-slate-300 text-slate-700 hover:bg-slate-50'}`}
  >
    {children}
  </button>
);

export const InfoTip = ({ text }) => (
  <span className="ml-1 text-slate-400 cursor-help" title={text}>ℹ️</span>
);

export default {
  RiskCard, RiskCardHeader, RiskCardBody, RiskBadge, RiskButton, RiskProgress, RiskChip, InfoTip
};


